module.exports = __webpack_public_path__ + "static/media/antigua-beaches-35.47ff56bb.jpg";